<template>
    <section
        class="relative flex flex-col items-center overflow-hidden max-lg:hidden">
        <div class="text-center">
            <AtomTitle> {{ title }} </AtomTitle>
            <p
                v-html="text"
                class="mx-auto mt-10 max-w-[65%] text-20/120 font-semibold text-accent-100" />
        </div>
        <InteractiveMap
            v-model="region"
            :regions="regionList"
            class="mx-auto mt-10" />
        <div class="mt-20 text-center">
            <BaseLink
                :to="buttonLink"
                target="_blank"
                icon-right="arrow-right"
                size="accent">
                {{ buttonText }}
            </BaseLink>
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import InteractiveMap from '~/components/particles/map-section/InteractiveMap.vue'
import type { MapRegion } from '~/components/particles/map-section/map-section.types'

const route = useRoute()

defineProps({
    title: {
        type: String as PropType<string>,
        default: 'Чем мы занимаемся',
    },
    regionList: {
        type: Array as PropType<MapRegion[]>,
        default: () => [],
    },
})

const region = ref()

let buttonText: string
let buttonLink: string
let text: string
//todo: переделать

if (isCromi()) {
    if (route.path === '/about/') {
        buttonText = 'Перейти в портфолио'
        text = `
            Наше оборудование представлено по&nbsp;всей России и&nbsp;в&nbsp;большинстве стран СНГ: Азербайджан, Армения, Белоруссия, Казахстан, Кыргызстан, Таджикистан, Узбекистан.
            <br><br>
            Благодаря компактным размерам товаров, даже самая дальняя доставка имеет низкую стоимость. А&nbsp;готовность всех необходимых сертификатов и&nbsp;экспортных документов делает покупку приятной и&nbsp;быстрой.
        `
        buttonLink = '/portfolio'
    } else {
        buttonText = 'Узнать больше о Cromi'
        text = `
            Производство, дистрибуция и&nbsp;продажа радиогидов, аудиогидов, пультов и&nbsp;кабин для синхронного перевода, радиооборудования Доступная среда.
            <br><br>
            Работаем с&nbsp;2010 года и&nbsp;являемся одной из&nbsp;первых компаний в&nbsp;своей отрасли.
        `
        buttonLink = '/about/'
    }
} else if (isRent()) {
    text = `
            Аренда оборудования для технического обеспечения деловых мероприятий под ключ. <br><br>
            Аренда радиогидов и&nbsp;аудиогидов для экскурсий. Офисы и&nbsp;склады в&nbsp;Санкт-Петербурге и&nbsp;Москве.
            Работаем по&nbsp;всей России.
        `
    buttonText = 'Перейти в портфолио'
    buttonLink = '/portfolio'
} else if (isRadioguide()) {
    text = `
            С&nbsp;2009 года предоставляем в&nbsp;аренду надежные комплекты радиогидов по&nbsp;всей стране и&nbsp;за&nbsp;её&nbsp;пределами. Наши заказчики успешно проводили выездные мероприятия с&nbsp;оборудованием Reinvox в&nbsp;десятках стран по&nbsp;всему миру.
            <br><br>
            Базируемся в&nbsp;Санкт-Петербурге и&nbsp;Москве.
        `
    buttonText = 'Перейти в портфолио'
    buttonLink = '/portfolio'
}
</script>
